import { all, call, put, takeEvery } from 'redux-saga/effects'
import getCostCenters from 'services/backend/cost-centers'
import actions from './actions'

export function* GET_DATA() {
  yield put({
    type: 'cost-centers/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const costCenters = yield call(getCostCenters)

  yield put({
    type: 'cost-centers/SET_STATE',
    payload: {
      costCenters,
      loading: false,
      ready: true,
    },
  })
}

export default function* rootSaga() {
  yield all([takeEvery(actions.GET_DATA, GET_DATA)])
}
